import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../AccessControl/AccessControlTypes';
import { Data, NeoModel } from '@singularsystems/neo-core';
import ProvisionalTaxReportsSearchCriteria from '../Models/Queries/ProvisionalTaxReportsSearchCriteria';
import InterestTransactionsLookup from '../Models/Lookups/InterestTransactionsLookup';
import ProvisionalTaxReportsApiClient from '../../ApiClients/ProvisionalTaxReportsApiClient';

export default class InterestTransactionsVM extends Views.ViewModelBase {
  public provisionalTaxReportsSearchCrtieria: ProvisionalTaxReportsSearchCriteria = new ProvisionalTaxReportsSearchCriteria();
  public interestTransactionsPageManager = new Data.PageManager(this.provisionalTaxReportsSearchCrtieria, InterestTransactionsLookup,
     this.provisionalTaxReportsApiClient.getInterestTransactionsPagedList, {
        pageSize: 10, 
        sortAscending: true,
        fetchInitial: false,
        sortBy: "eventDate",
        initialTaskRunner: this.taskRunner,
     }
   );
    constructor(
      taskRunner = AppService.get(Types.Neo.TaskRunner),
      private provisionalTaxReportsApiClient = AppService.get(Types.ApiClients.ProvisionalTaxReportsApiClient),
      private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
      super(taskRunner);
    } 

  public async initialise() {}

  public search(searchCriteria: ProvisionalTaxReportsSearchCriteria) {
    this.provisionalTaxReportsSearchCrtieria.mapFrom(searchCriteria);   
  }
}